import React, { useEffect } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import FloatingAudienceToggle from './components/FloatingAudienceToggle';
import HeroSection from './components/HeroSection';
import WhatKolanutDoesSection from './components/WhatKolanutDoesSection';
import BenefitsSection from './components/BenefitsSection';
import SocialProofSection from './components/SocialProofSection';
import CtaSection from './components/CtaSection';
import { SIGNUP_URL } from './engagementContent';

const EngagementHome = () => {
  useEffect(() => {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    if (window.location.hash) {
      const cleanUrl = `${window.location.pathname}${window.location.search}`;
      window.history.replaceState(null, '', cleanUrl);
    }
  }, []);

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Header />
      <FloatingAudienceToggle audience="d2c" />
      <main className="flex-grow pb-20 sm:pb-0">
        <HeroSection />
        <WhatKolanutDoesSection />
        <BenefitsSection />
        <SocialProofSection />
        <CtaSection />
      </main>
      <Footer />

      <div className="fixed bottom-0 left-0 right-0 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))] bg-white/40 backdrop-blur-md border-t border-gray-200/40 shadow-[0_-4px_20px_rgba(0,0,0,0.08)] sm:hidden z-40">
        <a
          href={SIGNUP_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center w-full py-3.5 rounded-full bg-[#8ae690] text-black font-bold text-base shadow-lg hover:bg-[#7ad67f] active:scale-[0.98] transition-all duration-200"
        >
          Get Started
        </a>
      </div>

      <style jsx global>{`
        html {
          scroll-behavior: smooth;
        }
        body {
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

export default EngagementHome;
